"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSettingsColumnDetails = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Slider = _interopRequireDefault(require("../slider/Slider"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TableSettingsColumnDetails = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TableSettingsColumnDetails, _Component);

  var _super = _createSuper(TableSettingsColumnDetails);

  function TableSettingsColumnDetails(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TableSettingsColumnDetails);
    _this = _super.call(this, props);
    _this.handleColumnWidthChange = _this.handleColumnWidthChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleWidthInputChange = _this.handleWidthInputChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleResetColumnWidth = _this.handleResetColumnWidth.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TableSettingsColumnDetails, [{
    key: "handleWidthInputChange",
    value: function handleWidthInputChange(event) {
      var parsedValue = event.target.value ? parseInt(event.target.value, 10) : 0;
      var max = this.props.maxWidth || this.props.maxColumnWidth;
      var value = Math.min(parsedValue, max);
      this.props.onColumnWidthChange(this.props.column, value);
    }
  }, {
    key: "handleColumnWidthChange",
    value: function handleColumnWidthChange(value) {
      this.props.onColumnWidthChange(this.props.column, value);
    }
  }, {
    key: "handleResetColumnWidth",
    value: function handleResetColumnWidth() {
      this.props.onResetColumnWidth(this.props.column);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$width = _this$props.width,
          width = _this$props$width === void 0 ? 0 : _this$props$width,
          _this$props$defaultWi = _this$props.defaultWidth,
          defaultWidth = _this$props$defaultWi === void 0 ? 0 : _this$props$defaultWi,
          maxWidth = _this$props.maxWidth,
          maxColumnWidth = _this$props.maxColumnWidth;
      var resetWidthButtonClassNames = (0, _classnames.default)('btn', 'btn-muted', 'btn-icon-only', 'btn-sm', 'margin-left-10', width === defaultWidth && 'disabled');
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'table-settings-item-body'
      }, /*#__PURE__*/_react.default.createElement(_Slider.default, {
        className: "margin-bottom-0",
        value: width,
        minValue: 0,
        maxValue: maxWidth || maxColumnWidth,
        step: 1,
        onChange: this.handleColumnWidthChange
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: resetWidthButtonClassNames,
        role: "button",
        onClick: this.handleResetColumnWidth
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: 'rioglyph rioglyph-revert'
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'column-width-input'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'input-group'
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: 'form-control text-right padding-right-5 no-controls',
        type: 'number',
        value: width || '',
        min: 0,
        max: maxWidth || maxColumnWidth,
        onChange: this.handleWidthInputChange
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: 'input-group-addon'
      }, 'px'))));
    }
  }]);
  return TableSettingsColumnDetails;
}(_react.Component);

exports.TableSettingsColumnDetails = TableSettingsColumnDetails;
TableSettingsColumnDetails.defaultProps = {
  //alias: '',
  onColumnWidthChange: function onColumnWidthChange() {
    return undefined;
  },
  onResetColumnWidth: function onResetColumnWidth() {
    return undefined;
  }
};
TableSettingsColumnDetails.propTypes = {
  column: _propTypes.default.string.isRequired,
  width: _propTypes.default.number,
  defaultWidth: _propTypes.default.number,
  maxWidth: _propTypes.default.number,
  maxColumnWidth: _propTypes.default.number.isRequired,
  //alias: PropTypes.string,
  onColumnWidthChange: _propTypes.default.func,
  onResetColumnWidth: _propTypes.default.func
};